// export const ADD_QUIZ = 'ADD_QUIZ'
// export const LOAD_QUIZ = 'LOAD_QUIZ'
// export const DELETE_QUIZ = 'DELETE_QUIZ'

const OPEN_POPUP_PRODUCT_DETAIL = 'OPEN_POPUP_PRODUCT_DETAIL';
const CLOSE_POPUP_PRODUCT_DETAIL = 'CLOSE_POPUP_PRODUCT_DETAIL';
const DISPLAY_LOADING_POPUP = 'DISPLAY_LOADING_POPUP';
const OPEN_REQUEST_FORM_PRODUCT = 'OPEN_REQUEST_FORM_PRODUCT';
const CLOSE_REQUEST_FORM_PRODUCT = 'CLOSE_REQUEST_FORM_PRODUCT';
const SET_DATA_BREADCRUMB = 'SET_DATA_BREADCRUMB';
const ADD_SHOPPING_CARD = 'ADD_SHOPPING_CARD';
const REMOVE_SHOPPING_CARD = 'REMOVE_SHOPPING_CARD';
const CLEAN_SHOPPING_CARD = 'CLEAN_SHOPPING_CARD';

export const ACTION_TYPES = {
  OPEN_POPUP_PRODUCT_DETAIL,
  CLOSE_POPUP_PRODUCT_DETAIL,
  DISPLAY_LOADING_POPUP,
  OPEN_REQUEST_FORM_PRODUCT,
  CLOSE_REQUEST_FORM_PRODUCT,
  SET_DATA_BREADCRUMB,
  ADD_SHOPPING_CARD,
  REMOVE_SHOPPING_CARD,
  CLEAN_SHOPPING_CARD
};



// WEBPACK FOOTER //
// ./constants/ActionTypes.js